<template>
    <div
        v-if="is_visible"
        class="fixed inset-x-0 bottom-0 z-50 flex flex-col items-center p-3 m-3 text-sm bg-white rounded shadow-lg md:flex-row md:max-w-lg md:mx-auto"
    >
        <div class="flex-grow mb-3 text-grey-darker md:mb-0">
            We use cookies for personalisation, analytics and ads. Read our
            <laroute-link
                :to="{ name: 'www.policies.cookies.show' }"
                class="no-underline text-blue"
            >
                cookie policy
            </laroute-link>
            for more info.
        </div>

        <button
            type="button"
            class="flex-none w-full btn btn-blue-lightest btn-sm md:w-auto"
            @click.prevent="close"
        >
            Close ({{ countdown }})
        </button>
    </div>
</template>

<script>
    import cookie from '../store/cookie'

    const COOKIE_NAME = 'seen-cookie-notice'

    let timeoutId

    export default {
        data () {
            return {
                countdown: 15,
                is_visible: false
            }
        },
        mounted () {
            this.is_visible = !cookie.has(COOKIE_NAME)

            if (this.is_visible) {
                timeoutId = setTimeout(this.tick, 1250)
            }

            cookie.set(COOKIE_NAME, true, { expires: 365 })
        },
        methods: {
            tick () {
                this.countdown -= 1

                if (this.countdown > 0) {
                    timeoutId = setTimeout(this.tick, 1250)
                } else {
                    this.close()
                }
            },
            close () {
                clearTimeout(timeoutId)

                this.is_visible = false
            }
        }
    }
</script>
